import { initDependencies, setupDependencies } from './app';
import './criticalResources';
import './services/polyfills';
import { runApp } from './services/runApp';

setupDependencies();
initDependencies();

runApp();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ((module as any).hot) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (module as any).hot.accept();
}
